import * as React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import ReactInputMask from 'react-input-mask';
import { lightBaseTheme as lightBaseThemeWithLegacy } from '../theme/index.js';
import { omitProps } from '../helpers/omitProps.js';

const ErrorMessage = styled.span.withConfig({
    displayName: "styles__ErrorMessage",
    componentId: "sc-f148e54c-0"
})`
    display: inline-block;
    height: 16px;
    margin-top: ${(props)=>props.theme.spacers.M};
    color: #f44336;
    font-family: inherit;
    font-style: italic;
    font-weight: bold;
    line-height: normal;
    font-size: 0.833em;
    letter-spacing: 0.02em;
`;
ErrorMessage.defaultProps = {
    theme: lightBaseThemeWithLegacy
};
const Label = styled(omitProps("active", "theme")("span")).withConfig({
    displayName: "styles__Label",
    componentId: "sc-f148e54c-1"
})`
    position: absolute;
    top: ${({ active  })=>active ? "0px" : "18px"};
    left: 0;
    user-select: none;
    color: ${(props)=>props.theme.colors["Level 4"]};
    height: 12px;
    white-space: nowrap;
    transition: all 0.2s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: none;

    ${(props)=>css(props.theme.typography.SmallCapsHeadline)}
`;
Label.defaultProps = {
    theme: lightBaseThemeWithLegacy
};
const Container = styled.label.withConfig({
    displayName: "styles__Container",
    componentId: "sc-f148e54c-2"
})`
    display: inline-block;
    position: relative;
    color: ${(props)=>props.theme.colors.Foreground};

    ${({ debug  })=>debug && css`
            &::after,
            &::before {
                content: '';
                display: block;
                position: absolute;
                box-sizing: border-box;
                width: 48px;
                height: 24px;
                background-color: tomato;
                border: 1px solid;
                opacity: 0.55;
                left: -1px;
                top: 1px;
            }

            &::before {
                top: 25px;
            }
        `}
`;
Container.defaultProps = {
    theme: lightBaseThemeWithLegacy
};
const InputComponent = ({ isMask , ...props })=>{
    if (isMask) {
        return /*#__PURE__*/ React.createElement(ReactInputMask, props);
    }
    return /*#__PURE__*/ React.createElement("input", props);
};
InputComponent.propTypes = {
    isMask: PropTypes.bool,
    ref: PropTypes.func
};
const StyledInput = styled(omitProps("withIconRight", "theme")(InputComponent)).withConfig({
    displayName: "styles__StyledInput",
    componentId: "sc-f148e54c-3"
})`
    ${(props)=>css(props.theme.typography.Paragraph)}
    line-height: 18px;
    box-sizing: border-box;
    width: 100%;
    padding: 24px 0 6px;
    outline: none;
    background: transparent;
    border: none;
    border-bottom: 2px solid ${(props)=>props.theme.colors["Level 4"]};
    color: inherit;

    ${({ withIconRight  })=>withIconRight && css`
            padding-right: 36px;
        `}

    &:focus ~ ${Label} {
        top: 0px;
    }

    &:invalid,
    :-moz-submit-invalid,
    :-moz-ui-invalid {
        box-shadow: none;
    }

    &:disabled {
        color: ${(props)=>props.theme.colors["Level 3"]};
    }
`;
StyledInput.defaultProps = {
    theme: lightBaseThemeWithLegacy
};
const IconContainer = styled(omitProps("active")("span")).withConfig({
    displayName: "styles__IconContainer",
    componentId: "sc-f148e54c-4"
})`
    position: absolute;
    right: 0;
    top: 6px;
    padding: 12px 0 0 12px;
    opacity: ${({ active  })=>active ? 1 : 0.65};
    cursor: pointer;
    outline: none;
`;

export { Container, ErrorMessage, IconContainer, Label, StyledInput };
